/**
 * Valid states for loading an object from an async service.
 * @type {{absent: string, loading: string, loaded: string, error: string}}
 */
export const LOADING_STATES = {
    /**
     * No attempt to load the object has been made yet.
     */
    absent: "absent",

    /**
     * The async call has been made and we're waiting for its response.
     */
    loading: "loading",

    /**
     * The object was loaded from the async service successfully.
     */
    loaded: "loaded",

    /**
     * The object could not be loaded for some reason.
     */
    error: "error"
};



// WEBPACK FOOTER //
// ./src/modules/user/constants.js